'use strict';

var _regeneratorRuntime = require("/Users/diego.sampaio/olx/connecting/chat-frontend/node_modules/@babel/runtime/regenerator/index.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _uuid = require('uuid');
var _constants = require('./constants');
require('./polyfills');
var _xmpp = require('./xmpp');
var _xmpp2 = _interopRequireDefault(_xmpp);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var Jaiminho = function () {
  function Jaiminho(username, password, domain, resource) {
    var service = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'ws://localhost:5280/websocket';
    var netInfo = arguments[5];
    var shouldAutoLoadRooms = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var increaseTimeout60 = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var shouldFetchInactiveAds = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : true;
    var deviceId = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;
    _classCallCheck(this, Jaiminho);
    this.lastSeenBuffer = [];
    var connectionData = {
      service: service,
      resource: resource,
      domain: domain,
      username: username,
      password: password
    };
    var extraData = {
      netInfo: netInfo,
      shouldAutoLoadRooms: shouldAutoLoadRooms,
      increaseTimeout60: increaseTimeout60,
      shouldFetchInactiveAds: shouldFetchInactiveAds
    };
    this.setDeviceId(deviceId);
    this.xmpp = new _xmpp2.default(connectionData, extraData);
  }
  _createClass(Jaiminho, [{
    key: 'isConnected',
    /**
    ====================================================================
    Mercurio
    ====================================================================
    */

    value: function isConnected() {
      return this.xmpp.isConnected();
    }
  }, {
    key: 'changeUser',
    value: function changeUser(username, password) {
      this.xmpp.changeUser(username, password);
    }
  }, {
    key: 'setDeviceId',
    value: function setDeviceId(deviceId) {
      this.deviceId = deviceId;
    }
  }, {
    key: 'connect',
    value: function connect() {
      this.xmpp.connect();
    }
  }, {
    key: 'disconnect',
    value: function disconnect() {
      this.xmpp.disconnect();
    }

    /**
    ====================================================================
    Chat Manager
    ====================================================================
    */
  }, {
    key: 'createRoom',
    value: function createRoom(listId, appVersion) {
      return this.chatManager.createRoom(listId, appVersion).then(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 1),
          chat = _ref2[0];
        return chat;
      });
    }
  }, {
    key: 'joinRoom',
    value: function joinRoom(roomname, appVersion) {
      var shouldLoadRoom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return this.chatManager.joinRoom(roomname, appVersion, shouldLoadRoom).then(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 1),
          chat = _ref4[0];
        return chat;
      });
    }
  }, {
    key: 'disableRoom',
    value: function disableRoom(roomname) {
      return this.chatManager.disableRoom(roomname);
    }
  }, {
    key: 'getChat',
    value: function getChat(roomname) {
      var shouldFetchInactiveAds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.chatManager.fetch({
        roomname: roomname,
        max: 1,
        shouldFetchInactiveAds: shouldFetchInactiveAds
      });
    }
  }, {
    key: 'getChats',
    value: function getChats(before, max) {
      var shouldFetchInactiveAds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return this.chatManager.fetch({
        before: before,
        max: max,
        shouldFetchInactiveAds: shouldFetchInactiveAds
      });
    }
  }, {
    key: 'updateLastSeen',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(roomname, unreadMessages) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.isConnected()) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt('return', this.chatManager.lastSeen(roomname, unreadMessages));
              case 2:
                this.lastSeenBuffer.push({
                  roomname: roomname,
                  unreadMessages: unreadMessages
                });
              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function updateLastSeen(_x9, _x10) {
        return _ref5.apply(this, arguments);
      }
      return updateLastSeen;
    }()

    /**
    ====================================================================
    Message Manager
    ====================================================================
    */
  }, {
    key: 'getMessages',
    value: function getMessages(roomname, before, max) {
      var queryId = (0, _uuid.v4)();
      return this.messenger.fetch({
        roomname: roomname,
        before: before,
        max: max,
        queryId: queryId
      });
    }
  }, {
    key: 'sendMessage',
    value: function sendMessage(roomname, text, beforeSendMessageCb, customType, appVersion) {
      var id = (0, _uuid.v4)();
      beforeSendMessageCb(roomname, id);
      var thread = {
        customType: customType,
        deviceId: this.deviceId,
        appVersion: appVersion
      };
      return this.messenger.send(roomname, text, id, thread);
    }

    /**
    ====================================================================
    Validator Manager
    ====================================================================
    */
  }, {
    key: 'blockUser',
    value: function blockUser(blockedId) {
      return this.validator.block(blockedId);
    }
  }, {
    key: 'denounceUser',
    value: function denounceUser(denouncedId, reason, roomname) {
      return this.validator.denounce(denouncedId, reason, roomname);
    }
  }, {
    key: 'unblockUser',
    value: function unblockUser(blockedId) {
      return this.validator.unblock(blockedId);
    }

    /**
    ====================================================================
    Subscribe
    ====================================================================
    */
  }, {
    key: 'onReceiveMessages',
    value: function onReceiveMessages(cb) {
      this.xmpp.on(_constants.Events.RECEIVED_MESSAGES, cb);
    }
  }, {
    key: 'onProfileValidation',
    value: function onProfileValidation(cb) {
      this.xmpp.on(_constants.Events.VALIDATE_PROFILE, cb);
    }
  }, {
    key: 'onReceiveChats',
    value: function onReceiveChats(cb) {
      this.xmpp.on(_constants.Events.RECEIVED_CHATS, cb);
    }
  }, {
    key: 'onReceiveStatus',
    value: function onReceiveStatus(cb) {
      this.xmpp.on(_constants.Events.RECEIVED_STATUS, cb);
    }
  }, {
    key: 'onError',
    value: function onError(cb) {
      this.xmpp.onError(cb);
    }
  }, {
    key: 'onOnline',
    value: function onOnline(cb) {
      var _this = this;
      this.xmpp.on(_constants.Events.ONLINE, function () {
        cb();
        _this.lastSeenBuffer.forEach(function (item) {
          _this.xmpp.updateLastSeen(item.roomname, item.unreadMessages);
        });
        _this.lastSeenBuffer = [];
      });
    }
  }, {
    key: 'chatManager',
    get: function get() {
      return this.xmpp.getPlugin('chatManager');
    }
  }, {
    key: 'messenger',
    get: function get() {
      return this.xmpp.getPlugin('messenger');
    }
  }, {
    key: 'validator',
    get: function get() {
      return this.xmpp.getPlugin('validator');
    }
  }, {
    key: 'connectionManager',
    get: function get() {
      return this.xmpp.getConnectionManager();
    }
  }]);
  return Jaiminho;
}();
exports.default = Jaiminho;